
import dayjs from "dayjs"

export const clearTruckFixCostFilterData = {
  TukId: null,
  TlrId: null,
  TukFixCostTypId: null,
  IsActv: 1,
  StrDteSt: null,
  StrDteEn: null,
  MonthDte: null,
}

export const initTruckFixCostFilterData = {
  ...clearTruckFixCostFilterData,
  // Defaults to this month so เฉลี่ย/เดือน is populated on first open — that column is
  // the point of the screen and is NULL without a month.
  MonthDte: dayjs().format("YYYY-MM-DD"),
}

export const initTruckFixCostDialogData = {
  TukFixCostId: null,
  TukFixCostTypId: 1,
  StrDte: dayjs().format("YYYY-MM-DD"),
  EndDte: dayjs().add(1, "year").subtract(1, "day").format("YYYY-MM-DD"),
  Amnt: 0,
  AmortTyp: "M",
  NumPrd: null,
  PrdAmnt: null,
  IntAmnt: null,
  SupId: null,
  DocNo: "",
  PayDte: null,
  PCItmId: null,
  IsActv: 1,
  Rmk: "",
  // one line per vehicle covered: { TukFixCostItmId?, TukId|TlrId, Amnt, Files[] }
  Items: [],
}
